import { useSpring, animated } from 'react-spring';

import styles from './MagicLine.module.scss';

interface IMagicLineProps {
  targetLeft: number;
  targetWidth: number;
}

export const MagicLine = ({ targetLeft, targetWidth }: IMagicLineProps) => {
  const { left, width } = useSpring({ left: targetLeft, width: targetWidth });

  return <animated.div className={styles.line} style={{ left, width }} />;
};
